


import{createbooking} from './routes/ordermanagment/createbooking/createbooking';
// import{contracts} from './routes/masterdata/contracts/contracts'
// import { rolemanagement } from './routes/menu/role/role';

interface page{
    compname:string,page:any
}
export const Pagearray :page[] = [

  




   {compname : 'Create Booking',page:createbooking},
//    {compname : 'User Role',page:rolemanagement},
   


    ]

export const pages = [
     createbooking,
    //rolemanagement
]
   